module.exports = __webpack_public_path__ + "static/media/loc2_img7.9fd0c411.jpg";